window.slate = window.slate || {};
window.theme = window.theme || {};
window.Marketo = window.Marketo || {};

/*================ Custom JS ================*/
'use strict';

(function ($) {
    "use strict";
    /*------------------------------------------------------------------
     [Table of contents]
     1. mega navigation menu init
     2. back to top
     3. twitter api init
     4. map popups
     5. single banner slider
     6. single banner slider version 2
     7. single banner slider version 3
     8. single banner slider version 4
     9. single banner slider version 5
     10. single banner slider version 6
     11. xs tab slider
     12. xs tab slider 6 col
     13. xs deal of the day
     14. xs product slider 1
     15. xs product slider 2
     16. xs product slider 3
     17. deal of the day
     18. product slider 4
     19. product slider 5
     20. product slider 6
     21. product slider 7
     22. organic product slider 8
     23. organic product slider 9
     24. organic product slider 10
     25. product slider 11
     26. product slider 12
     27. product slider 13
     28. seven column slider
     29. produt block slider
     30. xs progress
     31. input number increase
     32. echo init
     33. pulse effect
     34. countdown timer
     35 .ajax chimp init
     36. xs popover
     37. number percentage
     38. number counter up
     39. social tigger add class
     40. sync product preview slider
     41. sync banner nav slider
     42. insta feed
     43. jquery slider range
     44. contact form init
     45. Minicart dropdown remove close on body click
     46. Search form open by click
     47. Side Offset cart menu open
     48. Recent view slider
     49. vertical menu dropdown tigger on click overlay active init
     50. promo popup open when window is load
     51. video popup init
     52. Post gallery slider
     53. XpeedStudio Maps
     -------------------------------------------------------------------*/
    // my oel function

    $.fn.myOwl = function (options) {
        var settings = $.extend({
            items: 1,
            dots: false,
            loop: true,
            mouseDrag: true,
            touchDrag: true,
            nav: false,
            autoplay: true,
            navText: ['', ''],
            margin: 0,
            stagePadding: 0,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            navRewind: false,
            autoHeight: true,
            responsive: {}
        }, options);

        return this.owlCarousel({
            items: settings.items,
            loop: settings.loop,
            mouseDrag: settings.mouseDrag,
            touchDrag: settings.touchDrag,
            nav: settings.nav,
            navText: settings.navText,
            dots: settings.dots,
            margin: settings.margin,
            stagePadding: settings.stagePadding,
            autoplay: settings.autoplay,
            autoplayTimeout: settings.autoplayTimeout,
            autoplayHoverPause: settings.autoplayHoverPause,
            animateOut: settings.animateOut,
            animateIn: settings.animateIn,
            responsive: settings.responsive,
            navRewind: settings.navRewind,
            onTranslate: function onTranslate() {
                echo.render();
            }
        });
    };

    // function get height
    var getHeight = function getHeight() {
        var themeThumb = $('.xs-single-team .team-thumb'),
        thumbH = themeThumb.outerHeight(),
        hiringInfo = $('.xs-single-team.team-hiring-info');

        hiringInfo.css('min-height', thumbH);
    };

    //  email patern 
    function email_pattern(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    // menu vertical open and close when cross break point 
    function menuVertical() {
        var window_width = $(window).width(),
        breakPoint = 991,
        dropDonw_tigger = $('.v-menu-is-active .cd-dropdown-trigger'),
        dropdown = $('.v-menu-is-active .cd-dropdown'),
        activeClass = 'dropdown-is-active';

        if (window_width <= breakPoint) {
            if (dropDonw_tigger.hasClass(activeClass)) {
                dropDonw_tigger.removeClass(activeClass);
            }
            if (dropdown.hasClass(activeClass)) {
                dropdown.removeClass(activeClass);
            }
        } else {
            dropDonw_tigger.addClass(activeClass);
            dropdown.addClass(activeClass);
        }
    }

    // nav cover add remoe
    var navCover = function navCover() {
        $(window).width() <= 1023 ? $('.nav-cover').remove() : $('.xs-header').append('<div class="nav-cover"></div>');
    };

    $(window).on('load', function () {
        // menu vertical open and close when cross break point 
        menuVertical();
        // nav cover init
        navCover();
        // theme thumb equal height
        getHeight();
        /* banner slider verison 5 push bootstrap markup */
        $('.xs-banner-slider-5 .owl-dots').wrap('<div class="container container-fullwidth"><div class="row"><div class="col-lg-9 offset-lg-3"></div></div></div>');
    }); // END load Function 

    $(document).ready(function () {
        // menu vertical open and close when cross break point 
        menuVertical();
        // theme thumb equal height
        getHeight();


        

        /*==========================================================
         1. mega navigation menu init
         ======================================================================*/
         if ($('.xs-menus').length > 0) {
            $('.xs-menus').xs_nav({
                mobileBreakpoint: 991
            });
        }

        
        
        $(".xs-category-select").on("click", ".init", function() {
            $(this).closest(".xs-category-select").children('.xs-category-select li:not(.init)').toggle();
        });
        
        var allOptions = $(".xs-category-select").children('li:not(.init)');
        $("ul").on("click", "li:not(.init)", function() {
            allOptions.removeClass('selected');
            $(this).addClass('selected');
            $("ul").children('.init').html($(this).html());
            allOptions.toggle();
        });
        /*==========================================================
         2. back to top
         ======================================================================*/
         $(document).on('click', '.xs-back-to-top', function (event) {
            event.preventDefault();
            /* Act on the event */
            $('html, body').animate({
                scrollTop: 0
            }, 1000);
        });

        /*==========================================================
         3. twitter api init
         ======================================================================*/
         if ($('.xs-tweet').length > 0) {
            $('.xs-tweet').twittie({
                dateFormat: '%b. %d, %Y',
                template: '{{tweet}} <div class="date">{{date}}</div> <a href="{{url}}" target="_blank">Details</a>',
                count: 2,
                username: 'xpeedstudio',
                loadingText: 'Loading!'
            });
        }
        /*==========================================================
         4. map popups
         ======================================================================*/
         if ($('.xs-map-popup').length > 0) {
            $('.xs-map-popup').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        } 
        /*==========================================================
         5. single banner slider
         ======================================================================*/
         if ($('.xs-banner-slider').length > 0) {
            $(".xs-banner-slider").myOwl({
                items: 1,
                loop: false,
                navText: ['<i class="icon icon-arrow-left xs-simple-arrow"></i>', '<i class="icon icon-arrow-right xs-simple-arrow"></i>'],
                dots: true,
                nav: true,
                autoplay: false,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        dots: false,
                        nav: false
                    },
                    // breakpoint from 768 up
                    768: {
                        dots: true,
                        nav: true
                    }
                },
                afterAction: function afterAction() {
                    if (this.itemsAmount > this.visibleItems.length) {
                        $('.owl-next').removeClass('disabled');
                        $('.owl-prev').removeClass('disabled');
                        if (this.currentItem == 0) {
                            $('.owl-prev').addClass('disabled');
                        }
                        if (this.currentItem == this.maximumItem) {
                            $('.owl-next').addClass('disabled');
                        }
                    }
                }
            });
}

        /*==========================================================
         6. single banner slider version 2
         ======================================================================*/
         if ($('.xs-banner-slider-2').length > 0) {
            $(".xs-banner-slider-2").myOwl({
                dots: true
            });
        }

        /*==========================================================
         8. single banner slider version 4
         ======================================================================*/
         if ($('.xs-banner-slider-4').length > 0) {
            $(".xs-banner-slider-4").myOwl({
                dots: true,
                autoplay: false,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        dots: false
                    },
                    // breakpoint from 768 up
                    768: {
                        dots: true
                    }
                }
            });
        }

        /*==========================================================
         9. single banner slider version 5
         ======================================================================*/
         if ($('.xs-banner-slider-5').length > 0) {
            $(".xs-banner-slider-5").myOwl({
                dots: true,
                responsive: {
                    0: {
                        dots: false
                    },
                    768: {
                        dots: true
                    }
                }
            });
        }

        /*==========================================================
         10. single banner slider version 6
         ======================================================================*/
         if ($('.xs-banner-slider-6').length > 0) {
            $(".xs-banner-slider-6").myOwl({
                dots: true
            });
        }

        /*==========================================================
         12. xs tab slider 6 col
         ======================================================================*/
         var tabSixColSlider = $(".xs-tab-slider-6-col");
         tabSixColSlider.on('initialized.owl.carousel translated.owl.carousel', function () {
            var $this = $(this);
            $this.find('.owl-item.last-child').each(function () {
                $(this).removeClass('last-child');
            });
            $(this).find('.owl-item.active').last().addClass('last-child');
        });
         if ($('.xs-tab-slider-6-col').length > 0) {
            $(".xs-tab-slider-6-col").myOwl({
                items: 6,
                dots: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    // breakpoint from 480 up
                    480: {
                        items: 2
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 4
                    },
                    992: {
                        items: 5
                    },
                    1200: {
                        items: 6
                    }
                }
            });
        }

        /*==========================================================
         13. xs deal of the day
         ======================================================================*/
         if ($('.xs-slider-highlight').length > 0) {
            $(".xs-slider-highlight").myOwl({
                navText: ['<i class="icon icon-arrow-left xs-simple-arrow"></i>', '<i class="icon icon-arrow-right xs-simple-arrow"></i>'],
                nav: true,
                autoHeight:true
            });
        }
        /*==========================================================
         19. product slider 5
         ======================================================================*/
         if ($('.xs-product-slider-5').length > 0) {
            var productSliderFive = $('.xs-product-slider-5');
            productSliderFive.myOwl({
                items: 2,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    767: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 2
                    }
                }
            });
            $("#prev-6").on('click', function () {
                productSliderFive.trigger('prev.owl.carousel');
            });

            $("#next-6").on('click', function () {
                productSliderFive.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         20. product slider 6
         ======================================================================*/
         if ($('.xs-product-slider-6').length > 0) {
            var productSliderSix = $('.xs-product-slider-6');
            productSliderSix.myOwl({
                items: 2,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    767: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 2
                    }
                }
            });
            $("#prev-7").on('click', function () {
                productSliderSix.trigger('prev.owl.carousel');
            });

            $("#next-7").on('click', function () {
                productSliderSix.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         22. organic product slider 8
         ======================================================================*/
         if ($('.xs-product-slider-8').length > 0) {
            var productSliderEight = $('.xs-product-slider-8');
            productSliderEight.myOwl({
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2,
                        margin: 15
                    },
                    1024: {
                        items: 1,
                        margin: 0
                    }
                }
            });
            $("#prev-9").on('click', function () {
                productSliderEight.trigger('prev.owl.carousel');
            });

            $("#next-9").on('click', function () {
                productSliderEight.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         23. organic product slider 9
         ======================================================================*/
         if ($('.xs-product-slider-9').length > 0) {
            var productSliderNine = $('.xs-product-slider-9');
            productSliderNine.myOwl({
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2,
                        margin: 15
                    },
                    1024: {
                        items: 1,
                        margin: 0
                    }
                }
            });
            $("#prev-10").on('click', function () {
                productSliderNine.trigger('prev.owl.carousel');
            });

            $("#next-10").on('click', function () {
                productSliderNine.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         24. organic product slider 10
         ======================================================================*/
         if ($('.xs-product-slider-10').length > 0) {
            var productSliderTen = $('.xs-product-slider-10');
            productSliderTen.myOwl({
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2,
                        margin: 15
                    },
                    1024: {
                        items: 1,
                        margin: 0
                    }
                }
            });
            $("#prev-11").on('click', function () {
                productSliderTen.trigger('prev.owl.carousel');
            });

            $("#next-11").on('click', function () {
                productSliderTen.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         25. product slider 11
         ======================================================================*/
         if ($('.xs-product-slider-11').length > 0) {
            var productSliderEleven = $('.xs-product-slider-11');
            productSliderEleven.myOwl({
                items: 3,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
            $("#prev-12").on('click', function () {
                productSliderEleven.trigger('prev.owl.carousel');
            });
            $("#next-12").on('click', function () {
                productSliderEleven.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         26. product slider 12
         ======================================================================*/
         if ($('.xs-product-slider-12').length > 0) {
            var productSliderTwelve = $('.xs-product-slider-12');
            productSliderTwelve.myOwl({
                items: 3,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
            $("#prev-13").on('click', function () {
                productSliderTwelve.trigger('prev.owl.carousel');
            });
            $("#next-13").on('click', function () {
                productSliderTwelve.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         27. product slider 13
         ======================================================================*/
         if ($('.xs-product-slider-13').length > 0) {
            var productSliderThirteen = $('.xs-product-slider-13');
            productSliderThirteen.myOwl({
                items: 3,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
            $("#prev-14").on('click', function () {
                productSliderThirteen.trigger('prev.owl.carousel');
            });
            $("#next-14").on('click', function () {
                productSliderThirteen.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         28. seven column slider
         ======================================================================*/
         if ($(".xs-slider-7-col").length > 0) {
            var sevenColSlider = $(".xs-slider-7-col");
            sevenColSlider.on('initialized.owl.carousel translated.owl.carousel', function () {
                var $this = $(this);
                $this.find('.owl-item.last-child').each(function () {
                    $(this).removeClass('last-child');
                });
                $this.find('.owl-item.first-child').each(function () {
                    $(this).removeClass('first-child');
                });
                $(this).find('.owl-item.active').last().addClass('last-child');
                $(this).find('.owl-item.active').first().prev().addClass('first-child');
            });
            var sevenColSlider = $('.xs-slider-7-col');
            sevenColSlider.myOwl({
                items: 7,
                autoplay: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 7
                    }
                }
            });
            $("#prev-15").on('click', function () {
                sevenColSlider.trigger('prev.owl.carousel');
            });
            $("#next-15").on('click', function () {
                sevenColSlider.trigger('next.owl.carousel');
            });
        }

        /*==========================================================
         29. produt block slider
         ======================================================================*/
         if ($('.product-block-slider').length > 0) {
            $('.product-block-slider').myOwl({
                items: 1,
                dots: true
            });
        }

        /*==========================================================
         30. xs progress
         ======================================================================*/
         if ($('.xs-progress').length > 0) {
            $('.xs-progress').each(function () {
                $(this).find('.progress-bar').css({
                    width: $(this).find('.progress-bar').attr('aria-valuenow') + '%'
                });
            });
        }

        $('.rate-graph').each(function () {
            if ($(this).find('.rate-graph-bar').attr('data-percent') <= 100) {
                $(this).find('.rate-graph-bar').css({
                    width: $(this).find('.rate-graph-bar').attr('data-percent') + '%'
                });
            } else {
                $(this).find('.rate-graph-bar').css({
                    width: 100 + '%'
                });
            }
        });

        /*=============================================================
         31. input number increase
         =========================================================================*/

         var $this = $('.xs_input_number');
         $this.append('<span class="sub">-</span>');
         $this.append('<span class="add">+</span>');
         $('.xs_input_number').each(function () {
            var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            add = spinner.find('.add'),
            sub = spinner.find('.sub');
            input.parent().on('click', '.sub', function (event) {
                event.preventDefault();
                /* Act on the event */
                if (input.val() > parseInt(input.attr('min'))) input.val(function (i, oldval) {
                    return --oldval;
                });
            });
            input.parent().on('click', '.add', function () {
                event.preventDefault();
                if (input.val() < parseInt(input.attr('max'))) input.val(function (i, oldval) {
                    return ++oldval;
                });
            });
        });

        /*==========================================================
         32. echo init 
         ======================================================================*/


        echo.init({
            offset: 100,
            throttle: 100,
            unload: false,
            callback: function(element, op) {
            
            if(op === 'load') {
              $(element).removeClass('imager-loader-up');
            }
          }
        });
         if ($('.xs-nav-tab li a').length > 0) {
            $('.xs-nav-tab li a').on('click', function () {
                echo.render();
            });
        }

        /*----------------------------------------------------------------------
         33. pulse effect
         -------------------------------------------------------------------*/
         if ($('.add_to_wishlist').length > 0) {
            $('.add_to_wishlist').hover(function () {
                var $this = $(this).addClass('pulse_effect');
                setTimeout(function () {
                    $this.removeClass('pulse_effect');
                }, 500);
            });
        }

        /*==========================================================
         34. countdown timer
         ======================================================================*/
         $('.xs-countdown-timer[data-countdown]').each(function () {
            var $this = $(this),
            finalDate = $(this).data('countdown');
            $this.countdown(finalDate, function (event) {
                var $this = $(this).html(event.strftime(' ' + '<div class="xs-timer-container"><span class="timer-count">%-D </span><span class="timer-title">Days</span></div>' + '<div class="xs-timer-container"><span class="timer-count">%H </span><span class="timer-title">Hours</span></div>' + '<div class="xs-timer-container"><span class="timer-count">%M </span><span class="timer-title">Minutes</span></div>' + '<div class="xs-timer-container"><span class="timer-count">%S </span><span class="timer-title">Secods</span></div>'));
            });
        });


        /*==========================================================
         36. xs popover
         ======================================================================*/
         if ($('.btn[data-toggle="popover"]').length > 0) {
            // popover init
            $('.btn[data-toggle="popover"]').popover();
            // popover add class
            $('.btn[data-toggle="popover"]').on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                } else {
                    $(this).addClass('is-active');
                }
            });
        }

        /*==========================================================
         37. number percentage
         =======================================================================*/
         var number_percentage = $(".number-percentage");
         function animateProgressBar() {
            number_percentage.each(function () {
                $(this).animateNumbers($(this).attr("data-value"), true, parseInt($(this).attr("data-animation-duration"), 10));
            });
        }

        if ($('.waypoint-tigger').length > 0) {
            var waypoint = new Waypoint({
                element: document.getElementsByClassName('waypoint-tigger'),
                handler: function handler(direction) {
                    animateProgressBar();
                }
            });
        }

        /*==========================================================
         38. number counter up
         =======================================================================*/
         $.fn.animateNumbers = function (stop, commas, duration, ease) {
            return this.each(function () {
                var $this = $(this);
                var start = parseInt($this.text().replace(/,/g, ""), 10);
                commas = commas === undefined ? true : commas;
                $({
                    value: start
                }).animate({
                    value: stop
                }, {
                    duration: duration == undefined ? 500 : duration,
                    easing: ease == undefined ? "swing" : ease,
                    step: function step() {
                        $this.text(Math.floor(this.value));
                        if (commas) {
                            $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                        }
                    },
                    complete: function complete() {
                        if (parseInt($this.text(), 10) !== stop) {
                            $this.text(stop);
                            if (commas) {
                                $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                            }
                        }
                    }
                });
            });
};

        /*=============================================================
         39. social tigger add class
         =========================================================================*/
         if ($('.tigger-icon').length > 0) {
            $('.tigger-icon').on('click', function (event) {
                event.preventDefault();
                /* Act on the event */
                var this_item = $('.xs-social-tigger');
                if (this_item.hasClass('active')) {
                    this_item.removeClass('active');
                } else {
                    this_item.addClass('active');
                }
            });
        }

 $(document).on('shopify:section:load', function(e) {
     /*=============================================================
         40. sync product preview slider
         =========================================================================*/
         if ($('.sync-slider-preview').length > 0 && $('.sync-slider-thumb').length > 0) {
            var sync1 = $(".sync-slider-preview"),
            sync2 = $(".sync-slider-thumb"),
            slidesPerPage = 3,
            syncedSecondary = true;
            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                autoplay: false,
                dots: true,
                loop: false,
                responsiveRefreshRate: 200,
                navText: ['']
            });
            sync2.on('initialized.owl.carousel', function () {
                sync2.find(".owl-item").eq(0).addClass("current");
            }).owlCarousel({
                items: slidesPerPage,
                dots: false,
                nav: false,
                smartSpeed: 200,
                slideSpeed: 500,
                margin: 30,
            slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
            responsiveRefreshRate: 100,
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            }
        });
        }
 })

        /*=============================================================
         40. sync product preview slider
         =========================================================================*/
         if ($('.sync-slider-preview').length > 0 && $('.sync-slider-thumb').length > 0) {
            var sync1 = $(".sync-slider-preview"),
            sync2 = $(".sync-slider-thumb"),
            slidesPerPage = 3,
            syncedSecondary = true;
            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                autoplay: false,
                dots: true,
                loop: false,
                responsiveRefreshRate: 200,
                navText: ['']
            });
            sync2.on('initialized.owl.carousel', function () {
                sync2.find(".owl-item").eq(0).addClass("current");
            }).owlCarousel({
                items: slidesPerPage,
                dots: false,
                nav: false,
                smartSpeed: 200,
                slideSpeed: 500,
                margin: 30,
            slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
            responsiveRefreshRate: 100,
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            }
        });
        }

        /*=============================================================
         41. sync banner nav slider
         =========================================================================*/
         if ($('.nav-slider-content').length > 0 && $('.xs-slider-nav').length > 0) {
            var _syncPosition = function _syncPosition(el) {
                //if you set loop to false, you have to restore this next line
                //var current = el.item.index;

                //if you disable loop you have to comment this block
                var count = el.item.count - 1;
                var current = Math.round(el.item.index - el.item.count / 2 - .5);

                if (current < 0) {
                    current = count;
                }
                if (current > count) {
                    current = 0;
                }

                //end block

                sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
                var onscreen = sync2.find('.owl-item.active').length - 1;
                var start = sync2.find('.owl-item.active').first().index();
                var end = sync2.find('.owl-item.active').last().index();

                if (current > end) {
                    sync2.data('owl.carousel').to(current, 100, true);
                }
                if (current < start) {
                    sync2.data('owl.carousel').to(current - onscreen, 100, true);
                }
            };

            var _syncPosition2 = function _syncPosition2(el) {
                if (syncedSecondary) {
                    var number = el.item.index;
                    sync1.data('owl.carousel').to(number, 100, true);
                }
            };

            var sync1 = $(".nav-slider-content");
            var sync2 = $(".xs-slider-nav");
            var slidesPerPage = 9; //globaly define number of elements per page
            var syncedSecondary = true;

            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: true,
                autoplay: true,
                dots: true,
                loop: true,
                responsiveRefreshRate: 200,
                navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        nav: false
                    },
                    1024: {
                        nav: true
                    }
                }
            }).on('changed.owl.carousel', _syncPosition);

            sync2.on('initialized.owl.carousel', function () {
                sync2.find(".owl-item").eq(0).addClass("current");
            }).owlCarousel({
                items: slidesPerPage,
                dots: false,
                nav: false,
                smartSpeed: 200,
                slideSpeed: 500,
                slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                responsiveRefreshRate: 100,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 3
                    },
                    1024: {
                        items: 9
                    }
                }
            }).on('changed.owl.carousel', _syncPosition2);

            sync2.on("click", ".owl-item", function (e) {
                e.preventDefault();
                var number = $(this).index();
                sync1.data('owl.carousel').to(number, 300, true);
            });
        }

        /*=============================================================
         42. insta feed
         =========================================================================*/
         if ($('.widget.widget_instafeed').length > 0) {
            var access_token = $('.widget_instafeed').data('accesstoken');
            var client_id = $('.widget_instafeed').data('clientid');
            //alert(access_token)
        }

        /*$.fn.spectragram.accessData = {
            accessToken: access_token,
            clientID: client_id
        };
        $('.xs-demoFeed').spectragram('getUserFeed', {
            max: 9,
            size: 'small',
        });
*/


        /*==========================================================
         44. contact form init
         ======================================================================*/

         $(document).on('submit', '#xs-contact-form', function (event) {
            event.preventDefault();
            /* Act on the event */

            var xs_contact_name = $('#xs_contact_name'),
            xs_contact_email = $('#xs_contact_email'),
            xs_contact_subject = $('#xs_contact_subject'),
            x_contact_massage = $('#x_contact_massage'),
            xs_contact_submit = $('#xs_contact_submit'),
            xs_contact_error = false;

            $('.xpeedStudio_success_message').remove();

            if (xs_contact_name.val() === '') {
                xs_contact_name.addClass('invaild');
                xs_contact_error = true;
                xs_contact_name.focus();
                return false;
            } else {
                xs_contact_name.removeClass('invaild');
            }
            if (xs_contact_email.val() === '') {
                xs_contact_email.addClass('invaild');
                xs_contact_error = true;
                xs_contact_email.focus();
                return false;
            } else if (!email_pattern(xs_contact_email.val().toLowerCase())) {
                xs_contact_email.addClass('invaild');
                xs_contact_error = true;
                xs_contact_email.focus();
                return false;
            } else {
                xs_contact_email.removeClass('invaild');
            }
            if (xs_contact_subject.val() === '') {
                xs_contact_subject.addClass('invaild');
                xs_contact_error = true;
                xs_contact_subject.focus();
                return false;
            } else {
                xs_contact_subject.removeClass('invaild');
            }
            if (x_contact_massage.val() === '') {
                x_contact_massage.addClass('invaild');
                xs_contact_error = true;
                x_contact_massage.focus();
                return false;
            } else {
                x_contact_massage.removeClass('invaild');
            }

            if (xs_contact_error === false) {
                xs_contact_submit.before().hide().fadeIn();
                $.ajax({
                    type: "POST",
                    url: "assets/php/contact-form.php",
                    data: {
                        'xs_contact_name': xs_contact_name.val(),
                        'xs_contact_email': xs_contact_email.val(),
                        'xs_contact_subject': xs_contact_subject.val(),
                        'x_contact_massage': x_contact_massage.val()
                    },
                    success: function success(result) {
                        xs_contact_submit.after('<span class="xpeedStudio_success_message">' + result + '</span>').hide().fadeIn();

                        // $(".xpeedStudio_loader").fadeOut("normal", function() {
                        // 	$(this).remove();
                        // });

                $('#xs-contact-form')[0].reset();
            }
        });
            }
        });

        /*==========================================================
         45. Minicart dropdown remove close on body click
         ======================================================================*/
         if ($('.xs-miniCart-dropdown .dropdown-menu').length > 0) {
            $('.xs-miniCart-dropdown .dropdown-menu').on('click', function (e) {
                event.stopPropagation();
            });
        }

        /*==========================================================
         46. Search form open by click
         ======================================================================*/
         if ($('.navsearch-button').length > 0) {
            $('.navsearch-button').on('click', function (e) {
                e.preventDefault();

                if (!$('.navsearch-form').is(":visible")) {
                    $(this).find('i').removeClass('icon-search').addClass('icon-search-minus');
                } else {
                    $(this).find('i').removeClass('icon-search-minus').addClass('icon-search');
                }
                $(this).parent().parent().find('.navsearch-form').slideToggle(300);
            });
        }

        /*==========================================================
         47. Side Offset cart menu open
         ======================================================================*/
         if ($('.offset-cart-menu').length > 0) {
            $('.offset-cart-menu').on('click', function (e) {
                e.preventDefault();
                $('.xs-sidebar-group').addClass('isActive');
            });
        }
        if ($('.close-side-widget').length > 0) {
            $('.close-side-widget').on('click', function (e) {
                e.preventDefault();
                $('.xs-sidebar-group').removeClass('isActive');
            });
        }

        /*==========================================================
         48. Recent view slider
         ======================================================================*/
         if ($('.recent-view-slider').length > 0) {
            $('.recent-view-slider').myOwl({
                items: 6,
                margin: 20,
                nav: false,
                dots: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 6
                    }
                }
            });
        }

        /*==========================================================
         49. vertical menu dropdown tigger on click overlay active init
         ======================================================================*/
         if ($(window).width() >= 1024) {
            if ($('.cd-dropdown-trigger').length > 0) {
                $('.cd-dropdown-trigger').on('click', function () {
                    if ($('body').hasClass('isOverlayActive')) {
                        $('body').removeClass('isOverlayActive');
                    } else {
                        $('body').addClass('isOverlayActive');
                    }
                });
            }
        }

        /*==========================================================
         50. promo popup open when window is load
         ======================================================================*/
      /*  var now, time, lastTimePopup, repeatAfter;

        now = new Date();
        time = now.getTime();
        repeatAfter = 100 * 60 * 1000; //First number 100 is after number of minutes the popup should be showed.

        if (localStorage.getItem('lastTimePopup') !== null) {
            lastTimePopup = localStorage.getItem('lastTimePopup');
        }

        if (now - lastTimePopup >= repeatAfter || !lastTimePopup) {
            setTimeout(function () {
                if ($('.xs-promoPopup').length) {
                    if ($(window).width() >= 991) {
                        $.magnificPopup.open({
                            items: {
                                src: '.xs-promoPopup'
                            },
                            type: 'inline',
                            fixedContentPos: false,
                            fixedBgPos: true,
                            overflowY: 'auto',
                            closeBtnInside: true,
                            preloader: true,
                            midClick: true,
                            removalDelay: 300,
                            callbacks: {
                                beforeOpen: function beforeOpen() {
                                    this.st.mainClass = "my-mfp-zoom-in xs-promo-popup";
                                }
                            }
                        });
                    }
                }
            }, 1000);

            localStorage.setItem('lastTimePopup', now.getTime());
        }*/

        /*==========================================================
         51. video popup init
         ======================================================================*/
         if ($('.xs-video-popup').length > 0) {
            $('.xs-video-popup').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        }

        if ($('.popup-youtube').length > 0) {
            $('.popup-youtube').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        }
        /*==========================================================
         52. Post gallery slider
         ======================================================================*/
         if ($('.post-gallery-slider').length > 0) {
            $('.post-gallery-slider').myOwl({
                nav: true,
                navText: ['<i class="icon icon-arrow-right round-nav"></i>', '<i class="icon icon-arrow-left round-nav"></i>'],
                responsive: {
                    0: {
                        nav: false
                    },
                    768: {
                        nav: true
                    }
                }
            });
        }

        $('.cd-dropdown-trigger').on('click', function (e) {
            e.stopPropagation();
        });

        $('body').on('click', function () {
            if ($('body').hasClass('isOverlayActive')) {
                $('body').removeClass('isOverlayActive');
                $('.cd-dropdown-trigger').removeClass('dropdown-is-active');
                $('.cd-dropdown').removeClass('dropdown-is-active');
            }
        });
        

    $(window).on('scroll', function () {}); // END Scroll Function 

    $(window).on('resize', function () {
        // menu vertical open and close when cross break point 
        menuVertical();
        // nav cover init
        // navCover();
        // theme thumb equal height
        getHeight();
    }); // End Resize


          $(document).on('shopify:section:load', function(e) {
           if ($('.widget.widget_range').length > 0) {
            $("#slider-range").slider({
                range: true,
                min: parseInt($('#slider-range').data('min')),
                max: parseInt($('#slider-range').data('max')),
                step: parseInt($('#slider-range').data('step')),
                values: [parseInt($('#slider-range').data('min')), parseInt($('#slider-range').data('max'))],
                slide: function slide(event, ui) {
                    $('.collection-view').addClass('loader-filtetr');
                    $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
                    var targetUrlValue = ui.values[0] + "-" + ui.values[1];
                    //var targetUrlparam = targetUrlValue.toString();
                    var targetUrlparam = 'filterprice:'+targetUrlValue.toString();
                    var presentUrl = document.URL;
                    var newUrl = urlbuildfortags(targetUrlparam, presentUrl);
                    $.ajax({
                        url: newUrl,
                        type: "get",
                        success: function success(response) {
                            $('.collection-view').html('');
                            $('.collection-view').html($(response).find('.collection-view').html());
                            $('.collection-view').removeClass('loader-filtetr');
                            window.history.pushState({
                                path: newUrl
                            }, '', newUrl);
                            Wishlist.init();
                            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                        },
                        error: function error(jqXHR, textStatus, errorThrown) {
                            console.log(textStatus, errorThrown);
                        }
                    });
                }
            });
              $("#amount").val("$" + $("#slider-range").slider("values", 0) + " - $" + $("#slider-range").slider("values", 1));
            }
          })
        /*==========================================================
         43. jquery slider range
         ======================================================================*/
         if ($('#slider-range').length > 0) {
            $("#slider-range").slider({
                range: true,
                min: parseInt($('#slider-range').data('min')),
                max: parseInt($('#slider-range').data('max')),
                step: parseInt($('#slider-range').data('step')),
                values: [parseInt($('#slider-range').data('min')), parseInt($('#slider-range').data('max'))],
                slide: function slide(event, ui) {
                    $('.collection-view').addClass('loader-filtetr');
                    $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
                    var targetUrlValue = ui.values[0] + "-" + ui.values[1];
                    //var targetUrlparam = targetUrlValue.toString();
                    var targetUrlparam = 'filterprice:'+targetUrlValue.toString();
                    var presentUrl = document.URL;
                    var newUrl = urlbuildfortags(targetUrlparam, presentUrl);
                    $.ajax({
                        url: newUrl,
                        type: "get",
                        success: function success(response) {
                            $('.collection-view').html('');
                            $('.collection-view').html($(response).find('.collection-view').html());
                            $('.collection-view').removeClass('loader-filtetr');
                            window.history.pushState({
                                path: newUrl
                            }, '', newUrl);
                            Wishlist.init();
                            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                        },
                        error: function error(jqXHR, textStatus, errorThrown) {
                            console.log(textStatus, errorThrown);
                        }
                    });
                }
            });
$("#amount").val("$" + $("#slider-range").slider("values", 0) + " - $" + $("#slider-range").slider("values", 1));
}

  //Ordering Click
  $(document).on('change', '.shop-catelist-item select', function(e) {
    e.preventDefault();
    $('.collection-view').addClass('loader-filtetr');
    var $this = $(this);
    var targetUrlValue = $(this).val();
    var newUrl = document.URL;
    if (newUrl.indexOf('?') != -1) {
       var urlPart = newUrl.split('?')
       newUrl = urlPart[0] + '?sort_by=' + targetUrlValue;
   }
   else {
      newUrl = newUrl + '?sort_by=' + targetUrlValue;
  }
  
  $.ajax({
      url: newUrl,
      type: "get",
      success: function(response) {
        $('.collection-view').html('')
        $('.collection-view').html($(response).find('.collection-view').html())
        $('.collection-view').removeClass('loader-filtetr');
        window.history.pushState({
          path: newUrl
      }, '', newUrl);
        Wishlist.init()
        $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
    },
    error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);
    }
});
})

  //Category Click
  $(document).on('click', '.filter-by-collection ul li', function(e) {
    e.preventDefault();
    $('.collection-view').addClass('loader-filtetr');
    var $this = $(this);
    var targetUrlValue = $(this).data('target')
    var newUrl = window.location.origin;
    var newUrl = newUrl + '/collections/' + targetUrlValue;
    $.ajax({
      url: newUrl,
      type: "get",
      success: function(response) {
        $('.collection-view').html('')
        $('.collection-view').html($(response).find('.collection-view').html())
        $('.collec-sidebar').html($(response).find('.collec-sidebar').html())
        $('.collection-view').removeClass('loader-filtetr');
        window.history.pushState({
          path: newUrl
      }, '', newUrl);
        Wishlist.init()
        $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
    },
    error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);
    }
});
})

    //tag Click
    $(document).on('click', '.filter-by-tags ul li', function (e) {
        e.preventDefault();
        $('.collection-view').addClass('loader-filtetr');
        var $this = $(this);
        var targetUrlValue = $(this).data('target');
        var targetUrlparam = targetUrlValue.toString();
        if (targetUrlparam.indexOf('remove-') != -1) {
            $this.data('target', $(this).data('target').replace('remove-', ''));
        } else {
            $this.data('target', 'remove-' + $this.data('target'));
        }
        var presentUrl = document.URL;
        var newUrl = urlbuildfortags(targetUrlparam, presentUrl);
        $.ajax({
            url: newUrl,
            type: "get",
            success: function success(response) {
                $('.collection-view').html('');
                $('.collection-view').html($(response).find('.collection-view').html());
                $('.collec-sidebar').html($(response).find('.collec-sidebar').html())
                $('.collection-view').removeClass('loader-filtetr');
                window.history.pushState({
                    path: newUrl
                }, '', newUrl);
                Wishlist.init();
                $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    });
}); // end ready function
function urlbuildfortags(parameter, url) {
    var viewpart = '';
    if (url.indexOf('?') != -1) {
        url = url.split('?');
        viewpart = '?' + url[1];
        url = url[0];
    }
    var urlPart = url.split('/');
    if (urlPart[urlPart.length - 2] == 'collections') {
        var lastChar = url.substr(-1);
        if (lastChar != '/') {
            url = url + '/';
        }
    }

    var urlPart = url.split('/');
    var reptext = urlPart[urlPart.length - 1];
    var spreptext = reptext.split('+');
    
    if (url.indexOf('filterprice:') != -1 && parameter.indexOf('filterprice:') != -1) {
        var index = spreptext.indexOf(parameter);
        $(spreptext).each(function (index, item) {
            if(item.indexOf('filterprice:') != -1)
               spreptext.splice(index, 1);
       });
    }
    if (parameter.indexOf('remove-') != -1) {
        parameter = parameter.replace('remove-', '');
        var index = spreptext.indexOf(parameter);
        spreptext.splice(index, 1);
    } else {
        spreptext.push(parameter);
    }

    spreptext = spreptext.filter(function (entry) {
        return entry.trim() != '';
    });
    spreptext = spreptext.join('+');
    urlPart[urlPart.length - 1] = urlPart[urlPart.length - 1].replace(reptext, spreptext) + viewpart;
    url = urlPart.join('/');
    return url;
}
})(jQuery);

$(".xs-category-select").change(function () {
    var cat = $('#product_cat').val();
    window.location.href = window.location.origin + '/collections/' + cat;
});

$(".xs-category-select-mob").change(function () {
    var cat = $('#product_cat_mob').val();
    window.location.href = window.location.origin + '/collections/' + cat;
});
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

function floatToString(t, r) {
    var e = t.toFixed(r).toString();
    return e.match(/^\.\d+/) ? "0" + e : e
}

function attributeToString(t) {
    return "string" != typeof t && "undefined" === (t += "") && (t = ""), jQuery.trim(t)
}
"undefined" == typeof window.Shopify && (window.Shopify = {}), Shopify.money_format = "${{amount}}", Shopify.onError = function(t, r) {
    var e = eval("(" + t.responseText + ")");
    e.message ? alert(e.message + "(" + e.status + "): " + e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
}, Shopify.fullMessagesFromErrors = function(t) {
    var r = [];
    return jQuery.each(t, function(t, e) {
        jQuery.each(e, function(e, a) {
            r.push(t + " " + a)
        })
    }), r
}, Shopify.onCartUpdate = function(t) {
    alert("There are now " + t.item_count + " items in the cart.")
}, Shopify.onCartShippingRatesUpdate = function(t, r) {
    var e = "";
    r.zip && (e += r.zip + ", "), r.province && (e += r.province + ", "), e += r.country, alert("There are " + t.length + " shipping rates available for " + e + ", starting at " + Shopify.formatMoney(t[0].price) + ".")
},
 Shopify.onItemAdded = function(t) {
    alert(t.title + " was added to your shopping cart.")
}, Shopify.onProduct = function(t) {
    alert("Received everything we ever wanted to know about " + t.title)
}, Shopify.formatMoney = function(t, r) {
    function e(t, r) {
        return void 0 === t ? r : t
    }

    function a(t, r, a, o) {
        if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        i = r || this.money_format;
    switch (i.match(n)[1]) {
        case "amount":
            o = a(t, 2);
            break;
        case "amount_no_decimals":
            o = a(t, 0);
            break;
        case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            o = a(t, 0, ".", "");
            break;
        case "amount_with_space_separator":
            o = a(t, 2, ",", "");
            break;
        case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".")
    }
    return i.replace(n, o)
}, Shopify.resizeImage = function(t, r) {
    try {
        if ("original" == r) return t;
        var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        return e[1] + "_" + r + "." + e[2]
    } catch (r) {
        return t
    }
},Shopify.addedItemMessage = function() {
      jQuery('.card-opouu-area').modal('show');
},
Shopify.addItem = function(t, r, e) {
  jQuery('.ajax_add_to_cart').addClass('product-single-loader');
    var r = r || 1,
        a = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + r + "&id=" + t,
            dataType: "json",
            success: function(t) {
                "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
                 Shopify.addedItemMessage()
                 jQuery('.ajax_add_to_cart').removeClass('product-single-loader');
            },
            error: function(t, r) {
                Shopify.onError(t, r)
            }
        };
    jQuery.ajax(a)
},

Shopify.addItemWishList = function(t, r, e) {
    var r = r || 1,
        a = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + r + "&id=" + t,
            dataType: "json",
            success: function(t) {
                "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
            },
            error: function(t, r) {
                Shopify.onError(t, r)
            }
        };
    jQuery.ajax(a)
},
Shopify.addItemRelated = function(t, r, e) {
    var r = r || 1,
        a = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + r + "&id=" + t,
            dataType: "json",
            success: function(t) {
                "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
                 Shopify.addedItemMessage()
            },
            error: function(t, r) {
                Shopify.onError(t, r)
            }
        };
    jQuery.ajax(a)
}, 
Shopify.addItemPopup = function(t, r, e) {
    var r = r || 1,
        a = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + r + "&id=" + t,
            dataType: "json",
            success: function(t) {
                "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
                jQuery('.single_add_to_cart_button').html('<span class="added">Added</span>');
            },
            error: function(t, r) {
                Shopify.onError(t, r)
            }
        };
    jQuery.ajax(a)
}, 

Shopify.addItemFromFormPopUp = function() {
}, Shopify.addItemFromForm = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/add.js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onItemAdded(t)
            jQuery('.xs-sidebar-group').addClass('isActive');
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}, Shopify.getCart = function(t) {
    jQuery.getJSON("/cart.js", function(r) {
        "function" == typeof t ? t(r) : Shopify.onCartUpdate(r)
    })
}, Shopify.pollForCartShippingRatesForDestination = function(t, r, e) {
    e = e || Shopify.onError;
    var a = function() {
        jQuery.ajax("/cart/async_shipping_rates", {
            dataType: "json",
            success: function(e, o, n) {
                200 === n.status ? "function" == typeof r ? r(e.shipping_rates, t) : Shopify.onCartShippingRatesUpdate(e.shipping_rates, t) : setTimeout(a, 500)
            },
            error: e
        })
    };
    return a
}, Shopify.getCartShippingRatesForDestination = function(t, r, e) {
    e = e || Shopify.onError;
    var a = {
        type: "POST",
        url: "/cart/prepare_shipping_rates",
        data: Shopify.param({
            shipping_address: t
        }),
        success: Shopify.pollForCartShippingRatesForDestination(t, r, e),
        error: e
    };
    jQuery.ajax(a)
}, Shopify.getProduct = function(t, r) {
    jQuery.getJSON("/products/" + t + ".js", function(t) {
        "function" == typeof r ? r(t) : Shopify.onProduct(t)
    })
}, Shopify.changeItem = function(t, r, e) {
    var a = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + r + "&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(a)
}, Shopify.removeItem = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}, Shopify.clear = function(t) {
    var r = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(r) {
            "function" == typeof t ? t(r) : Shopify.onCartUpdate(r)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(r)
}, Shopify.updateCartFromForm = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}, Shopify.updateCartAttributes = function(t, r) {
    var e = "";
    jQuery.isArray(t) ? jQuery.each(t, function(t, r) {
        var a = attributeToString(r.key);
        "" !== a && (e += "attributes[" + a + "]=" + attributeToString(r.value) + "&")
    }) : "object" == typeof t && null !== t && jQuery.each(t, function(t, r) {
        e += "attributes[" + attributeToString(t) + "]=" + attributeToString(r) + "&"
    });
    var a = {
        type: "POST",
        url: "/cart/update.js",
        data: e,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(a)
}, Shopify.updateCartNote = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/update.js",
        data: "note=" + attributeToString(t),
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(t) {
    var r = [],
        e = function(t, e) {
            e = jQuery.isFunction(e) ? e() : e, r[r.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
        };
    if (jQuery.isArray(t) || t.jquery) jQuery.each(t, function() {
        e(this.name, this.value)
    });
    else
        for (var a in t) Shopify.buildParams(a, t[a], e);
    return r.join("&").replace(/%20/g, "+")
}, Shopify.buildParams = function(t, r, e) {
    jQuery.isArray(r) && r.length ? jQuery.each(r, function(r, a) {
        rbracket.test(t) ? e(t, a) : Shopify.buildParams(t + "[" + ("object" == typeof a || jQuery.isArray(a) ? r : "") + "]", a, e)
    }) : null != r && "object" == typeof r ? Shopify.isEmptyObject(r) ? e(t, "") : jQuery.each(r, function(r, a) {
        Shopify.buildParams(t + "[" + r + "]", a, e)
    }) : e(t, r)
}, Shopify.isEmptyObject = function(t) {
    for (var r in t) return !1;
    return !0
});

  function mini_cart_item_add(cart){
    var dynamicHTML='';
    var sym=$('.cart-popup-container').data('currency')
    if(cart.items.length==0){
        $('.cart-popup-container').html($('.cart-popup-container').data('empty'));
        $('.cart-count').text(0)
      // $('.cart-count').addClass('hidden-count')
      return false;
    }

    for(var k in cart.items) { 
      dynamicHTML   += '<li class="mini_cart_item media">'
                    + '<a href="'+ cart.items[k].url+'" class="d-flex mini-product-thumb">'
                    + '<img src="' + cart.items[k].image +  '" alt="'+ cart.items[k].image.alt +'"></a>'         
                    + '<div class="media-body"><h4 class="mini-cart-title">'
                    + '<a href="'+ cart.items[k].url+'">' + cart.items[k].title  +' </a></h4>'
                    + '<span class="quantity">'+ cart.items[k].quantity + ' × <span class="amount">' + Shopify.formatMoney(cart.items[k].price, sym) + '</span></span></div>'
                    + '<a href="javascript:void(0)" onclick="Shopify.changeItem('+cart.items[k].id+',0,mini_cart_item_add)" class="btn-cancel pull-right"> x </a>'
                    + '</li>';
    }
 var popuptext =   '<ul class="xs-miniCart-menu woocommerce">' + dynamicHTML + '<li class="mini-cart-btn">'
                   + '<p class="woocommerce-mini-cart__total total"><strong>Subtotal:</strong><span class="woocommerce-Price-amount amount">'+Shopify.formatMoney(cart.total_price, sym)+'</span></p>'
                   + '<li class="d-flex mini-cart-button-area"><p class="woocommerce-mini-cart__buttons buttons xs-btn-wraper">'
                   + '<a href="/cart" class="button btn btn-primary badge badge-pill wc-forward">View cart</a>'
                   + '<form action="/cart" method="post" novalidate class="cart"><input type="submit" name="checkout" class="button btn btn-primary badge badge-pill checkout wc-forward" value="Checkout"></form>'
                   + '</p></li>'
                   + '</ul>'

     $('.cart-popup-container').html(popuptext);
     $('.cart-popup-container').prepend('<p>'+$('.cart-popup-container').attr('title')+'</p>');
     $('.cart-count').text(cart.item_count)

  }
  function mini_cart_add(cart){
    Shopify.getCart(mini_cart_item_add); 
  }

  function mini_cart_add(cart){
    Shopify.getCart(mini_cart_item_add); 
  }
             
function cartpopupopen(a,b){
  var newUrl=b += (b.split('?')[1] ? '&':'?') +'view=qview';
  //alert(newUrl)
   $.ajax({
     url: newUrl,
     type: "get",
     success: function (response) {
       $('.quick-view-layout-default').html($(response).find('.quick-view-layout-default').html())
       Wishlist.init()
        popupSwiper =new Swiper(".swiper-container.quick-view-popup-swiper", {
            navigation: {
            nextEl: '.swiper-button-next-popup',
            prevEl: '.swiper-button-prev-popup',
          },
           pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable:true
          },
        })
        var getWishlist = JSON.parse(localStorage.getItem('xstore_wishlist'));
        if (getWishlist !== undefined && getWishlist !== null) {
            if(getWishlist.indexOf(a)!=-1){
              $('#quick-view-popup .add-to-wishlist.wishlist a').addClass('is-active')
            }else{
              $('#quick-view-popup .add-to-wishlist.wishlist a').removeClass('is-active')
            }
        }
     },
     error: function(jqXHR, textStatus, errorThrown){
       console.log(textStatus, errorThrown);
     }
   });
   $('.popup-modal').click();
   return false
  //popupSwiper.update();
}

function quickviewpopup(a,b){
  var newUrl=b += (b.split('?')[1] ? '&':'?') +'view=qview';
   $.ajax({
     url: newUrl,
     type: "get",
     success: function (response) {
      $('.quick-view-container').html($(response).filter('.quick-view-layout').html())
     //Wishlist.init()
      $('.xs-quick-view-modal').modal('show');
     },
     error: function(jqXHR, textStatus, errorThrown){
       console.log(textStatus, errorThrown);
     }
   });
   $('.xs-modal').click();
   return false
}

$(function() {   
$('form[action^="/cart/add"]').submit(function(){
   Shopify.addItemFromForm($(this).attr('id'), mini_cart_add);
   return false
})

/*$('.popup-modal').magnificPopup({
  removalDelay: 500, 
  callbacks: {
    beforeOpen: function() {
       this.st.mainClass ='mfp-zoom-out';
    }
  },
  midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});
*/
$(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
});
})
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */


 slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
   function Variants(options) {

    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
     _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);
      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
     _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
     _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
     _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
     _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

  _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

/*  _updateSKU: function(evt) {
      var variant = evt.variant;
      // Update the sku
      $('.variant-sku').html(variant.sku);
    },*/

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
     _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
     _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    //this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    //this.$container.on('variantSKUChange' + this.namespace, this.updateProductSku.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    updateProductSku: function(evt) {
      var variant = evt.variant;
      // Update the sku
      $('.variant-sku').html(variant.sku);
    },
    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


Marketo.banner = {
    section: {
        init: function(t) {
        $(".banner-slider").owlCarousel({
                items: 1,
                loop: false,
                navText: ['<i class="icon icon-arrow-left xs-simple-arrow"></i>', '<i class="icon icon-arrow-right xs-simple-arrow"></i>'],
                dots: false,
                nav: true,
                autoHeight:true,
                autoplayHoverPause:true,
                autoplay: false,
                afterAction: function () {
                    if (this.itemsAmount > this.visibleItems.length) {
                        $('.owl-next').removeClass('disabled');
                        $('.owl-prev').removeClass('disabled');
                        if (this.currentItem == 0) {
                            $('.owl-prev').addClass('disabled');
                        }
                        if (this.currentItem == this.maximumItem) {
                            $('.owl-next').addClass('disabled');
                        }
                    }
                }
            })
},
destroy: function() {}
}
},


theme.Banner = function() {
    function t(t) {
        this.$container = $(t);
        this.$container.attr("data-section-id");
        this.settings = {}, this.namespace = ".banner", this.onLoad()
    }
    return t.prototype = $.extend({}, t.prototype, {
        onLoad: function() {
            if ($('.banner-slider').length > 0) {
              Marketo.banner.section.init(this.$container)
            }
     },
     onUnload: function() {
            this.$container.off(this.namespace),
            Marketo.banner.section.destroy(this.$container)
           }
       }),
    t
}()

Marketo.xstabslider6col = {
    section: {
        init: function(t) {
       var tabSixColSlider = $(".xs-tab-slider-6-col");
        tabSixColSlider.on('initialized.owl.carousel translated.owl.carousel', function () {
            var $this = $(this);
            $this.find('.owl-item.last-child').each(function () {
                $(this).removeClass('last-child');
            });
            $(this).find('.owl-item.active').last().addClass('last-child');
        });
        $(".xs-tab-slider-6-col").owlCarousel({
                items: 6,
                dots: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 480 up
                    480: {
                        items: 2,
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 4,
                    },
                    992: {
                        items: 5,
                    },
                    1200: {
                        items: 6,
                    }
                }
            })
},
destroy: function() {}
}
},

theme.Xstabslider6col = function() {
    function t(t) {
        this.$container = $(t);
        this.$container.attr("data-section-id");
        this.settings = {}, this.namespace = ".xstabslider6col", this.onLoad()
    }
    return t.prototype = $.extend({}, t.prototype, {
        onLoad: function() {
            if ($('.xs-tab-slider-6-col').length > 0) {
              Marketo.xstabslider6col.section.init(this.$container)
            }
     },
     onUnload: function() {
            this.$container.off(this.namespace),
            Marketo.xstabslider6col.section.destroy(this.$container)
           }
       }),
    t
}()
Marketo.productslider = {
    section: {
        init: function (t) {
        var xsProuctSliderOne = $(".xs-product-slider-1");
            xsProuctSliderOne.myOwl({
                responsive: {
                    // breakpoint from 768 up
                    768: {
                        items: 1,
                    },
                    1024: {
                        items: 1,
                    }
                }
            });
            
            $("#prev-1").on('click', function () {
                xsProuctSliderOne.trigger('prev.owl.carousel');
            });
            
            $("#next-1").on('click', function () {
                xsProuctSliderOne.trigger('next.owl.carousel');
            });
            
            var xsProuctSliderTwo = $(".xs-product-slider-2");
            xsProuctSliderTwo.myOwl({
                responsive: {
                    // breakpoint from 768 up
                    768: {
                        items: 1,
                    },
                    1024: {
                        items: 1,
                    }
                }
            });
            $("#prev-2").on('click', function () {
                xsProuctSliderTwo.trigger('prev.owl.carousel');
            });

            $("#next-2").on('click', function () {
                xsProuctSliderTwo.trigger('next.owl.carousel');
            });
            
             var xsProuctSliderThree = $(".xs-product-slider-3");
            xsProuctSliderThree.myOwl({
                responsive: {
                    // breakpoint from 768 up
                    768: {
                        items: 1,
                    },
                    1024: {
                        items: 1,
                    }
                }
            });
            $("#prev-3").on('click', function () {
                xsProuctSliderThree.trigger('prev.owl.carousel');
            });

            $("#next-3").on('click', function () {
                xsProuctSliderThree.trigger('next.owl.carousel');
            });
            
        },
        destroy: function () {}
    }
},
        
 theme.Productslider = function () {
            function t(t) {
                this.$container = $(t);
                this.$container.attr("data-section-id");
                this.settings = {}, this.namespace = ".productslider", this.onLoad()
            }
            return t.prototype = $.extend({}, t.prototype, {
                onLoad: function () {
                    if ($('.xs-product-slider-1').length > 0) {
                        Marketo.productslider.section.init(this.$container)
                    }
                    if ($('.xs-product-slider-2').length > 0) {
                        Marketo.productslider.section.init(this.$container)
                    }
                    if ($('.xs-product-slider-3').length > 0) {
                        Marketo.productslider.section.init(this.$container)
                    }
                },
                onUnload: function () {
                    this.$container.off(this.namespace),
                            Marketo.productslider.section.destroy(this.$container)
                }
            }),
                    t
        }()
        
        
        

Marketo.xstabslider = {
    section: {
        init: function (t) {
            var tabSlider = $(".xs-tab-slider");
            tabSlider.on('initialized.owl.carousel translated.owl.carousel', function () {
                var $this = $(this);
                $this.find('.owl-item.last-child').each(function () {
                    $(this).removeClass('last-child');
                });
                $(this).find('.owl-item.active').last().addClass('last-child');
            });
            if ($('.xs-tab-slider').length > 0) {
                $(".xs-tab-slider").myOwl({
                    items: 3,
                    margin: 30,
                    stagePadding: 10,
                    dots: true,
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            items: 1,
                        },
                        // breakpoint from 768 up
                        768: {
                            items: 2,
                        },
                        992: {
                            items: 2,
                        },
                        1200: {
                            items: 3,
                        }
                    }
                })
            }
        },
        destroy: function () {}
    }
},
        theme.Xstabslider = function () {
            function t(t) {
                this.$container = $(t);
                this.$container.attr("data-section-id");
                this.settings = {}, this.namespace = ".xstabslider", this.onLoad()
            }
            return t.prototype = $.extend({}, t.prototype, {
                onLoad: function () {
                    if ($('.xs-tab-slider').length > 0) {
                        Marketo.xstabslider.section.init(this.$container)
                    }
                },
                onUnload: function () {
                    this.$container.off(this.namespace),
                            Marketo.xstabslider.section.destroy(this.$container)
                }
            }),
                    t
        }()


Marketo.dealoftheweek = {
    section: {
        init: function(t) {
        
            var dealOfTheWeek = $('.xs-deal-of-the-week');
            dealOfTheWeek.myOwl({
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2,
                    },
                    991: {
                        items: 1
                    }
                }
            });
            $("#prev-4").on('click', function () {
                dealOfTheWeek.trigger('prev.owl.carousel');
            });

            $("#next-4").on('click', function () {
                dealOfTheWeek.trigger('next.owl.carousel');
            });


            var productSliderSeven = $('.xs-product-slider-7');
            productSliderSeven.myOwl({
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 1,
                    },
                    1024: {
                        items: 1,
                    }
                }
            });
            $("#prev-8").on('click', function () {
                productSliderSeven.trigger('prev.owl.carousel');
            });

            $("#next-8").on('click', function () {
                productSliderSeven.trigger('next.owl.carousel');
            });
           
},
destroy: function() {}
}
},

theme.Dealoftheweek = function() {
    function t(t) {
        this.$container = $(t);
        this.$container.attr("data-section-id");
        this.settings = {}, this.namespace = ".dealoftheweek", this.onLoad()
    }
    return t.prototype = $.extend({}, t.prototype, {
        onLoad: function() {
            if ($('.xs-deal-of-the-week').length > 0) {
              Marketo.dealoftheweek.section.init(this.$container)
            }
         if ($('.xs-product-slider-7').length > 0) {
              Marketo.dealoftheweek.section.init(this.$container)
          }

       $('.xs-countdown-timer[data-countdown]').each(function () {
            var $this = $(this),
                finalDate = $(this).data('countdown');
            $this.countdown(finalDate, function (event) {
                var $this = $(this).html(event.strftime(' '
                        + '<div class="xs-timer-container"><span class="timer-count">%-D </span><span class="timer-title">Days</span></div>'
                        + '<div class="xs-timer-container"><span class="timer-count">%H </span><span class="timer-title">Hours</span></div>'
                        + '<div class="xs-timer-container"><span class="timer-count">%M </span><span class="timer-title">Minutes</span></div>'
                        + '<div class="xs-timer-container"><span class="timer-count">%S </span><span class="timer-title">Secods</span></div>'));
            });
        });
     },
     onUnload: function() {
            this.$container.off(this.namespace),
            Marketo.dealoftheweek.section.destroy(this.$container)
           }
       }),
    t
}()
Marketo.mainslider = {
    section: {
        init: function(t) {
        $(".xs-banner-slider").myOwl({
                items: 1,
                loop: false,
                navText: ['<i class="icon icon-arrow-left xs-simple-arrow"></i>', '<i class="icon icon-arrow-right xs-simple-arrow"></i>'],
                dots: true,
                nav: true,
                autoplay: false,
                responsive: {
                    0: {
                        dots: false,
                        nav: false,
                    },
                    768: {
                        dots: true,
                        nav: true,
                    }
                },
                afterAction: function () {
                    if (this.itemsAmount > this.visibleItems.length) {
                        $('.owl-next').removeClass('disabled');
                        $('.owl-prev').removeClass('disabled');
                        if (this.currentItem == 0) {
                            $('.owl-prev').addClass('disabled');
                        }
                        if (this.currentItem == this.maximumItem) {
                            $('.owl-next').addClass('disabled');
                        }
                    }
                }
            })
},
destroy: function() {}
}
},
theme.Mainslider = function() {
    function t(t) {
        this.$container = $(t);
        this.$container.attr("data-section-id");
        this.settings = {}, this.namespace = ".mainslider", this.onLoad()
    }
    return t.prototype = $.extend({}, t.prototype, {
        onLoad: function() {
            if ($('.xs-banner-slider').length > 0) {
              Marketo.mainslider.section.init(this.$container)
            }
     },
     onUnload: function() {
            this.$container.off(this.namespace),
            Marketo.mainslider.section.destroy(this.$container)
           }
       }),
    t
}()

Marketo.mainslidertwo = {
    section: {
        init: function(t) {
            $(".xs-banner-slider-3").myOwl({
                dots: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        dots: false,
                    },
                    // breakpoint from 768 up
                    768: {
                        dots: true,
                    }
                }
            })
        },
        destroy: function() {}
    }
},
theme.Mainslidertwo = function() {
    function t(t) {
        this.$container = $(t);
        this.$container.attr("data-section-id");
        this.settings = {}, this.namespace = ".mainslidertwo", this.onLoad()
    }
    return t.prototype = $.extend({}, t.prototype, {
        onLoad: function() {
            if ($('.xs-banner-slider-3').length > 0) {
              Marketo.mainslidertwo.section.init(this.$container)
          }
      },
      onUnload: function() {
        this.$container.off(this.namespace),
        Marketo.mainslidertwo.section.destroy(this.$container)
    }
}),
    t
}()

Marketo.mainsliderthree = {
	section: {
		init: function(t) {
			$(".xs-banner-slider-2").myOwl({
				dots: true
            })
		},
		destroy: function() {}
	}
},

theme.Mainsliderthree = function() {

	function t(t) {
		this.$container = $(t);
		this.$container.attr("data-section-id");
		this.settings = {}, this.namespace = ".mainsliderthree", this.onLoad()
	}
	return t.prototype = $.extend({}, t.prototype, {
		onLoad: function() {
			if ($('.xs-banner-slider-2').length > 0) {
				Marketo.mainsliderthree.section.init(this.$container)
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace),
			Marketo.mainsliderthree.section.destroy(this.$container)
		}
	}),
	t
}()


Marketo.mainsliderfour = {
	section: {
		init: function(t) {
			$(".xs-banner-slider-4").myOwl({
				dots: true,
                autoplay: false,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        dots: false,
                    },
                    // breakpoint from 768 up
                    768: {
                        dots: true,
                    }
                }
            })
		},
		destroy: function() {}
	}
},
theme.Mainsliderfour = function() {
	function t(t) {
		this.$container = $(t);
		this.$container.attr("data-section-id");
		this.settings = {}, this.namespace = ".mainsliderfour", this.onLoad()
	}
	return t.prototype = $.extend({}, t.prototype, {
		onLoad: function() {
			if ($('.xs-banner-slider-4').length > 0) {
				Marketo.mainsliderfour.section.init(this.$container)
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace),
			Marketo.mainsliderfour.section.destroy(this.$container)
		}
	}),
	t
}()

Marketo.productwidgetslider = {
    section: {
        init: function (t) {
        var xsProuctSliderOne = $(".xs-product-slider-4");
            xsProuctSliderOne.myOwl({
                items: 2,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 2,
                    }
                }
            });
            
            $("#prev-5").on('click', function () {
                xsProuctSliderOne.trigger('prev.owl.carousel');
            });
            
            $("#next-5").on('click', function () {
                xsProuctSliderOne.trigger('next.owl.carousel');
            });
            
            
            var xsProuctSliderTwo = $(".xs-product-slider-5");
            xsProuctSliderTwo.myOwl({
                items: 2,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 2,
                    }
                }
            });
            $("#prev-6").on('click', function () {
                xsProuctSliderTwo.trigger('prev.owl.carousel');
            });

            $("#next-6").on('click', function () {
                xsProuctSliderTwo.trigger('next.owl.carousel');
            });
            
             var xsProuctSliderThree = $(".xs-product-slider-6");
             xsProuctSliderThree.myOwl({
                items: 2,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 2,
                    }
                }
            });

            $("#prev-7").on('click', function () {
                xsProuctSliderThree.trigger('prev.owl.carousel');
            });

            $("#next-7").on('click', function () {
                xsProuctSliderThree.trigger('next.owl.carousel');
            });
        },
        destroy: function () {}
    }
},
        
 theme.Productwidgetslider = function () {
            function t(t) {
                this.$container = $(t);
                this.$container.attr("data-section-id");
                this.settings = {}, this.namespace = ".productwidgetslider", this.onLoad()
            }
            return t.prototype = $.extend({}, t.prototype, {
                onLoad: function () {
                    if ($('.xs-product-slider-4').length > 0) {
                        Marketo.productwidgetslider.section.init(this.$container)
                    }
                    if ($('.xs-product-slider-5').length > 0) {
                        Marketo.productwidgetslider.section.init(this.$container)
                    }
                    if ($('.xs-product-slider-6').length > 0) {
                        Marketo.productwidgetslider.section.init(this.$container)
                    }
                },
                onUnload: function () {
                    this.$container.off(this.namespace),
                            Marketo.productwidgetslider.section.destroy(this.$container)
                }
            }),
                    t
        }()
        
        
        
// =require sections/offers-tab-with-product.js

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */
$( document ).ready(function() {
theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  if (!$newAddressForm.length) {
    return;
  }
  
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();
})
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */
$( document ).ready(function() {
theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();
})
// =require js/collection-filter.js

$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('banner-slider', theme.Banner);
    sections.register('xs-tab-slider-6-col', theme.Xstabslider6col);
    sections.register('xs-product-slider-1', theme.Productslider);
    sections.register('xs-tab-slider', theme.Xstabslider);
    sections.register('deal-of-the-week', theme.Dealoftheweek);
    sections.register('main-slider', theme.Mainslider);
    sections.register('main-slider-two', theme.Mainslidertwo);
    sections.register('main-slider-3', theme.Mainsliderthree);
    sections.register('main-slider-4', theme.Mainsliderfour);
    sections.register('widget-slider', theme.Productwidgetslider);
    sections.register('productslider7', theme.Productslider7);
    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));
    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
            '.rte iframe[src*="youtube.com/embed"],' +
            '.rte iframe[src*="player.vimeo"]';
    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    //Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
});

$( document ).ready(function() {
 $('.nav-item a.nav-link').on('shown.bs.tab', function(event){
     $(".xs-tab-slider-6-col").trigger("refresh.owl.carousel");
     $(".xs-tab-slider").trigger("refresh.owl.carousel");
  });
  })


